const imgZoom = () => {
  const style = `.cpb-zoom-img-container {
    position: absolute;
    overflow: hidden;
    background-color: #FFF;
    border: 2px solid black;
    border-radius: 8px;
    opacity: 0;
    transform: translateY(20px);
    box-shadow: 2px 1px 20px 6px #00000024;
    z-index: 10;
  }
  
  .cpb-zoom-img-container.show {
    transform: translateY(0px);
    opacity: 1;
  }`;
  const styleElem = document.createElement('style');
  styleElem.textContent = style;
  document.querySelector('#product-builder').appendChild(styleElem);
  
  function getViewImageURL(scale, view) {
    if (typeof window.cpbImageStorage === 'undefined') return;
    view = view || 'front';
    var getDataURL = cpbImageStorage.views[view].getSnapshot(scale);
    return getDataURL;
  }

  const views = ['front', 'back', 'left', 'right'];
  let transitionDuration = 300;
  
  const canvasList = document.querySelectorAll('.konvajs-content');

  const mouseEnterHandle = (e) => {
    let scale = 3;
    let addWidth = 0;
    let addHeight = 0;
    const DOMRect = e.target.getBoundingClientRect();
    const activeSlide = document.querySelector('.swiper-slide-active');
    const view = views[[...activeSlide.parentElement.children].indexOf(activeSlide)];
    const url = getViewImageURL(scale, view);
    const img = document.createElement('img');
    img.src = url;
    img.style.maxWidth = 'none';
    
    const container = document.createElement('div');
    container.classList.add('cpb-zoom-img-container');
    container.appendChild(img);
    document.body.appendChild(container);
    
    // container.style.width = `${DOMRect.width + addWidth}px`;
    container.style.width = `200px`;
    // container.style.height = `${DOMRect.height + addHeight}px`;
    container.style.height = `200px`;
    // container.style.top = `${DOMRect.y + scrollY - (addHeight / 2)}px`;
    // container.style.left = `${DOMRect.x + DOMRect.width}px`;
    container.style.transition = `transform ${transitionDuration}ms`;
    container.style.borderRadius = '50%';
    container.style.pointerEvents = 'none';

    container.classList.add('show');

    let transX = 0;
    let transY = 0;

    const updatePosition = (e) => {
      transX = ((e.clientX - DOMRect.x) * scale - (DOMRect.width + addWidth) / 5) * -1;
      transY = ((e.clientY - DOMRect.y) * scale - (DOMRect.height + addHeight) / 5) * -1;

      container.style.top = `${e.clientY - 100 + scrollY}px`;
      container.style.left = `${e.clientX - 100}px`;
      
      img.style.transform = `translateX(${transX}px) translateY(${transY}px)`;
    }


    e.target.addEventListener('mousemove', updatePosition);
  }

  const mouseLeaveHandle = () => {
    document.querySelector('.cpb-zoom-img-container').classList.remove('show');
    setTimeout(() => {
      document.querySelector('.cpb-zoom-img-container').remove()
    }, transitionDuration);
  }

  canvasList.forEach(canvas => {
    canvas.style.cursor = 'none';
    canvas.addEventListener('mouseenter', mouseEnterHandle);
    canvas.addEventListener('mouseleave', mouseLeaveHandle);
  })  
}
var cpbLoaded = function() {
    if (jQuery('.cpb-render-konva').length > 0) {
      console.log('start');
      
      imgZoom();
      
    } else {
      window.requestAnimationFrame(cpbLoaded);
    }   
};

cpbLoaded();